import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { APP_NAME } from "@/lib/constants";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-5 bg-background px-6 text-center">
      <span className="font-display text-6xl font-semibold tracking-tight text-primary">404</span>
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-muted">
        <Compass className="h-5 w-5 text-muted-foreground" aria-hidden="true" />
      </div>
      <div className="flex flex-col gap-1.5">
        <h1 className="font-display text-xl font-semibold">This page doesn't exist</h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          The link may be broken, or the page may have moved. Let's get you back to {APP_NAME}.
        </p>
      </div>
      <Button asChild>
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
